import { render, staticRenderFns } from "./HostedSignalingServer.vue?vue&type=template&id=61244d8c&scoped=true"
import script from "./HostedSignalingServer.vue?vue&type=script&lang=js"
export * from "./HostedSignalingServer.vue?vue&type=script&lang=js"
import style0 from "./HostedSignalingServer.vue?vue&type=style&index=0&id=61244d8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61244d8c",
  null
  
)

export default component.exports